import ErrorMessageTemplate from 'common/components/ErrorMessageTemplate';
import React from 'react';
import ReactDOM from 'react-dom';

const mainContainer = document.querySelector('#application-error-container');
const dataStatus = mainContainer?.getAttribute('data-status');
const element = <ErrorMessageTemplate dataStatus={dataStatus} />;
ReactDOM.render(element, mainContainer);
